<div (click)="closePopup()" class="imgSize"><img alt="img" src="./assets/Cross_NEG.svg"></div>
<div class="vidPos">
  <video width="832" height="440"  id="videoPlayer" controls autoplay>
    <source src={{sourceLink}} type="video/mp4">
      Unable to load the video
      <track label="English" kind="captions" srclang="en" src="" default>
  </video>
</div>

